import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/yuz-dolgusu-sonrasi-alkol-aliminin-sonuclari/page.tsx");
